import React, { useContext } from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import {Form, InputNumber} from "antd";

const IngredientsQuantity = ({responseIndex}) => {

    const [form] = Form.useForm()
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleQuantityChange = (list) => {
        let mockRows = Object.assign({}, recipeById)
        mockRows.billOfMaterials[responseIndex].amount = list.quantity
        setRecipeById(mockRows)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span: 24}}
            >
                <Form.Item
                    name={'quantity'}
                    initialValue={recipeById.billOfMaterials[responseIndex].amount}
                >
                    <InputNumber onChange={() => handleQuantityChange(form.getFieldsValue())} step={0.1} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default IngredientsQuantity
